import { Moon, Sun } from "lucide-react";
import { useTheme } from "next-themes";

import { SidebarMenuButton } from "@ospra/design-system/components/sidebar";

export function ThemeToggle() {
  const { theme, setTheme } = useTheme();

  return (
    <SidebarMenuButton
      className="w-full justify-start gap-3"
      onClick={() => setTheme(theme === "dark" ? "light" : "dark")}
      tooltip="Toggle theme"
    >
      <div className="relative flex h-4 w-4 items-center justify-center">
        <Sun className="dark:-rotate-90 h-4 w-4 rotate-0 scale-100 transition-all dark:scale-0" />
        <Moon className="absolute h-4 w-4 rotate-90 scale-0 transition-all dark:rotate-0 dark:scale-100" />
      </div>
      <span className="font-medium text-xs">
        {theme === "dark" ? "Light Mode" : "Dark Mode"}
      </span>
    </SidebarMenuButton>
  );
}
